var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgOnDemandWebinar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 192,
  height: 192,
  viewBox: "0 0 192 192",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M33 27C33 23.6863 35.6863 21 39 21H153C156.314 21 159 23.6863 159 27V114H33V27Z",
  fill: "#C3AFD9"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M42 33C42 31.3431 43.3431 30 45 30H147C148.657 30 150 31.3431 150 33V99C150 100.657 148.657 102 147 102H45C43.3431 102 42 100.657 42 99V33Z",
  fill: "#E5DCEF",
  stroke: "#8D64B3",
  strokeWidth: 3.2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M159 114H33L12.3167 155.367C12.1084 155.783 12 156.242 12 156.708V165C12 168.314 14.6863 171 18 171H174C177.314 171 180 168.314 180 165V156.708C180 156.242 179.892 155.783 179.683 155.367L159 114Z",
  fill: "#C3AFD9"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M48.75 114L38.4575 141.447C37.722 143.408 39.1719 145.5 41.2665 145.5H150.733C152.828 145.5 154.278 143.408 153.542 141.447L143.25 114",
  stroke: "#8D64B3",
  strokeWidth: 3.2
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M62.25 114L53.8125 145.5M129.75 114L138.188 145.5",
  stroke: "#8D64B3",
  strokeWidth: 3.2
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M75.75 114L70.6875 145.5M116.25 114L121.312 145.5",
  stroke: "#8D64B3",
  strokeWidth: 3.2
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M89.25 114L87.5625 145.5M102.75 114L104.438 145.5",
  stroke: "#8D64B3",
  strokeWidth: 3.2
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M12 159H180",
  stroke: "#8D64B3",
  strokeWidth: 3.2
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M33 114H159",
  stroke: "#8D64B3",
  strokeWidth: 3.2
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M45 124.5H147",
  stroke: "#8D64B3",
  strokeWidth: 3.2
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M42 135H150",
  stroke: "#8D64B3",
  strokeWidth: 3.2
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M42 33C42 31.3431 43.3431 30 45 30H147C148.657 30 150 31.3431 150 33V99C150 100.657 148.657 102 147 102H45C43.3431 102 42 100.657 42 99V33Z",
  stroke: "#8D64B3",
  strokeWidth: 3.2
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M110.406 66.2201L87.7822 52.3947C86.7826 51.7838 85.5 52.5032 85.5 53.6746V81.3254C85.5 82.4968 86.7826 83.2162 87.7822 82.6053L110.406 68.7799C111.363 68.195 111.363 66.805 110.406 66.2201Z",
  fill: "#C3AFD9",
  stroke: "#C3AFD9",
  strokeWidth: 3.2
})));
export default SvgOnDemandWebinar;